<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="720px">
        <v-card>
          <v-card-title class="text-h5">
            <!-- {{ title }} -->
            Retailer Sales
          </v-card-title>

          <v-card-text>

            <v-container>
              <v-row>
                <!-- <v-col cols="12">
                  <v-btn color="primary" class="ml-auto">
                    <download-csv :data="exportData" :name="`${fileName}.csv`">
                      <v-icon dense>mdi-download</v-icon>
                      Export
                    </download-csv>
                  </v-btn>
                </v-col> -->
                <v-col cols="12" class="mt-0 pt-0">
                  <v-data-table
                    :headers="table.headers"
                    :items="table.data"
                    :items-per-page="10"
                    :loading="table.loading"
                    item-key="id"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                  >
                    <template v-slot:[`item.amount`]="{ item }">
                      {{ item.amount.toLocaleString() }}
                    </template>

                    <template v-slot:[`item.name`]="{ item }">
                      {{ item.name ? item.name : "-" }}
                    </template>
                    <template
                      v-for="header in table.headers.filter((header) =>
                        header.hasOwnProperty('formatter')
                      )"
                      v-slot:[`item.${header.value}`]="{ value }"
                    >
                      {{ header.formatter(value) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <!-- <v-btn text @click.native="cancel">
              No
            </v-btn> -->
            <v-btn @click.native="cancel">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "RetailerSalesList",
  data() {
    return {
      exportData: [],
      fileName: "",

      dialog: false,
      resolve: null,
      reject: null,
      // message: null,
      // title: null,
      // options: {
      //   color: "grey lighten-3",
      //   width: 400,
      //   zIndex: 200,
      //   noconfirm: false,
      // },

      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,

        headers: [
          {
            text: "Name",
            align: "start",
            value: "name",
            // formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "Date",
            align: "start",
            sortable: false,
            value: "SoldDate",
            formatter: (x) => (x ? this.formatDate(x) : null),
          },

          {
            text: "Account Number",
            align: "start",
            value: "accountNumber",
            sortable: false,
            // formatter: (x) => this.setToLocaleString(x),
          },
          {
            text: "SKU",
            align: "center",
            sortable: false,
            value: "soldskuName",
          },
          {
            text: "SKU Price",
            align: "center",
            sortable: false,
            value: "Total",
            formatter: (x) => this.setToLocaleString(x),
          },
        ],
        data: [],
      },
    };
  },

  methods: {
    open(data) {
      this.dialog = true;
      this.getRetailerSales(data.retailerId);
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    async getRetailerSales(retailerId) {
      this.table.loading = true;
      await this.$drs
        .get(`data-report?method=retailerSalesList&retailerId=${retailerId}`)
        .then((response) => {
          // console.log(response)
          this.table.loading = false;
          const newArr = response.data.data;
          console.log( newArr.list);
          this.table.data = newArr.list;
          // console.log(newArr.retailersTransactionsUpload);
          // this.$nextTick(() => {

          // });
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
